<template>
  <div class="warp">
    <el-form label-width="auto">
      <el-row :gutter="20">
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--收件人-->
          <el-descriptions-item :label="$t('newOrder.RecipientName')">
            <encryption-field
              field-name="receiveName"
              :encrypted-value="receiverInfo.receiveName"
              :label="$t('newOrder.RecipientName')"
            />
          </el-descriptions-item>
          <!--收件人公司-->
          <el-descriptions-item :label="$t('newOrder.RecipientCompany')">
            <encryption-field
              field-name="receiveCompany"
              :encrypted-value="receiverInfo.receiveCompany"
              :label="$t('newOrder.RecipientCompany')"
            />
          </el-descriptions-item>
          <!--收件人手机-->
          <el-descriptions-item :label="$t('newOrder.Recipientphone')">
            <encryption-field
              field-name="receiveMobile"
              :encrypted-value="receiverInfo.receiveMobile"
              :label="$t('newOrder.Recipientphone')"
            />
          </el-descriptions-item>
          <!--街道-->
          <el-descriptions-item :label="$t('newOrder.Street1')">
            <encryption-field field-name="receiveStreet" :encrypted-value="receiverInfo.receiveStreet" :label="$t('newOrder.Street1')" />
          </el-descriptions-item>
          <!--收件人门牌号-->
          <el-descriptions-item :label="$t('newOrder.doorNumber')">
            <encryption-field field-name="receiveHouseNumber" :encrypted-value="receiverInfo.receiveHouseNumber" :label="$t('newOrder.doorNumber')" />
          </el-descriptions-item>
          <!--收件人区-->
          <el-descriptions-item :label="$t('newOrder.RecipientDistrict')">
            <encryption-field field-name="receiveArea" :encrypted-value="receiverInfo.receiveArea" :label="$t('newOrder.RecipientDistrict')" />
          </el-descriptions-item>
          <!--收件人城市-->
          <el-descriptions-item :label="$t('newOrder.RecipientCity')">
            <div>{{ receiverInfo.receiveCity || '--' }}</div>
          </el-descriptions-item>
          <!--收件人州-->
          <el-descriptions-item :label="$t('newOrder.RecipientState')">
            <div>{{ receiverInfo.receiveState || '--' }}</div>
          </el-descriptions-item>
          <!--收件人邮编-->
          <el-descriptions-item :label="$t('newOrder.RecipientZipCode')">
            <div>{{ receiverInfo.receiveZipcode || '--' }}</div>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="1" direction="vertical">
          <!--收件人地址补充-->
          <el-descriptions-item :label="$t('GlobalSetObj.recipientComplement')">
            <encryption-field
              field-name="receiveComplement"
              :encrypted-value="receiverInfo.receiveComplement"
              :label="$t('GlobalSetObj.recipientComplement')"
            />
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--收件人税号-->
          <el-descriptions-item :label="$t('newOrder.RecipientCPFCNPJ')">
            <encryption-field
              field-name="receiveTax"
              :encrypted-value="receiverInfo.receiveTax"
              :label="$t('newOrder.RecipientCPFCNPJ')"
            />
          </el-descriptions-item>
          <!--国家注册号-->
          <el-descriptions-item :label="$t('GlobalSetObj.NationalRegistrationNumber')">
            <encryption-field field-name="receiveIeNumber" :encrypted-value="receiverInfo.receiveIeNumber" :label="$t('GlobalSetObj.NationalRegistrationNumber')" />
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="1" direction="vertical">
          <!--收件地址-->
          <el-descriptions-item :label="$t('newOrder.ReceivingAddress')">
            <encryption-field
              field-name="receiveAddress"
              :encrypted-value="receiverInfo.receiveAddress"
              :label="$t('newOrder.ReceivingAddress')"
            />
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--收件人电话-->
          <el-descriptions-item :label="$t('newOrder.Recipientphonenumber')">
            <encryption-field
              :field-name="receiverInfo.receivePhone?'receivePhone':'receiveMobile'"
              :encrypted-value="receiverInfo.receivePhone?receiverInfo.receivePhone:receiverInfo.receiveMobile"
              :label="$t('newOrder.Recipientphonenumber')"
            />
          </el-descriptions-item>
          <!--收件人邮箱-->
          <el-descriptions-item :label="$t('newOrder.RecipientEmail')">
            <encryption-field
              field-name="receiveMail"
              :encrypted-value="receiverInfo.receiveMail"
              :label="$t('newOrder.RecipientEmail')"
            />
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'RecipientsInfo',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'encryption-field': () => import('@/components/EncryptionField/index.vue')
  },
  props: {
    receiverInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    encryptionReceiverInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    }
  },
  data() {
    return {
      showDetail: true,
      showDetail1: true,
      showDetail2: true,
      showDetail3: true,
      showDetail4: true,
      showDetail5: true,
      showDetail6: true,
      showDetail7: true
    };
  },
  methods: {
    handlerhidden(item, value) {
      const buttonPermissions = this.$store.getters.button_permissions;
      const promise = 'field:customer-sensitive-info';
      const hasPromise = buttonPermissions.includes(promise);
      if (hasPromise) {
        if (item === 'name') {
          this.showDetail = !this.showDetail;
        }
        if (item === 'receivePhone') {
          this.showDetail1 = !this.showDetail1;
        }
        if (item === 'receiveMobile') {
          this.showDetail2 = !this.showDetail2;
        }
        if (item === 'receiveMail') {
          this.showDetail3 = !this.showDetail3;
        }
        if (item === 'receiveTax') {
          this.showDetail4 = !this.showDetail4;
        }
        if (item === 'receiveCompany') {
          this.showDetail5 = !this.showDetail5;
        }
        if (item === 'receiveAddress') {
          this.showDetail6 = !this.showDetail6;
        }
        if (item === 'receiveComplement') {
          this.showDetail7 = !this.showDetail7;
        }
      } else {
        this.$message.error(this.$t('GlobalSetObj.sensitiveInfoPermission'));
      }
    }
  }
};
</script>

<style scoped>
.warp /deep/ .el-col {
  height: 50px;
}

.iconEye {
  cursor: pointer;
  margin-left: 10px;
}

.warp /deep/ .el-descriptions-item__label {
  font-size: 13px;
  color: #909399;
}

.warp /deep/ .el-descriptions-item__cell {
  /*height: 35px !important;*/
  padding-bottom: 2px !important;
}

.el-descriptions-item__cell div {
  font-weight: bold;
  font-size: 15px;
}
</style>
